import React, {useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import {useOvermind} from "../Others/OvermindHelper";
import {BrowserRouter} from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import {useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {getContentHeightWidth, getParentHeightWidth} from '../Others/GlobalMethods'
import LeftPart from "./BasicStructures/LeftPart";
import RightPart from "./BasicStructures/RightPart";

const styles = {
    parent: getParentHeightWidth(),
    checker: {
        background: "#FFF"
    }
}

const getRightPartComponent = (state) => {
    if (state.belowSm) {
        if (state.drawerState) {
            return null;
        } else {
            return <RightPart/>
        }
    } else {
        return <RightPart/>
    }
}

const Portfolio = () => {
    const {state, actions} = useOvermind()
    const theme = useTheme()
    const belowSm = useMediaQuery(theme.breakpoints.down('sm'))
    const bigDevice = useMediaQuery(theme.breakpoints.up(1500))

    useEffect(() => {
        actions.setBelowSm(belowSm)
        actions.setBigDevice(bigDevice)
    }, [bigDevice, belowSm])

    return (
        <Grid container style={{backgroundColor: state.primaryColor, ...styles.parent}}>
            <BrowserRouter>
                <Grid container justify='center' alignItems='center' alignContent='center'>
                    <Paper elevation={16} style={getContentHeightWidth(belowSm)}>
                        <Grid container direction='row'>
                            {
                                state.drawerState && <LeftPart/>
                            }
                            {
                                getRightPartComponent(state)
                            }
                        </Grid>
                    </Paper>
                </Grid>
            </BrowserRouter>
        </Grid>
    );
};

export default Portfolio;
